import messages from '../../../locale/messages';
import { containsMalicious, inputDescLimit } from '../../../helpers/textRestriction';

const validate = values => {

  const errors = {}

  if (!values.content) {
    errors.content = messages.required;
  } else if (values.content && values.content.toString().trim() == '') {
    errors.content = messages.required;
  } else if (values?.content?.length > inputDescLimit) {
    errors.content = messages.descriptionFieldRestriction;
  } else if (containsMalicious(values.content)) {
    errors.content = messages.invalidInput;;
  }

  return errors;
}

export default validate;